import React, { useState } from 'react'
import Content from 'blocks.app/content/content'
import Uploader from 'blocks.app/uploader'
import translate from 'core/translate'
import { isHorizontalMenu } from 'core/helpers/menu'
import { cn } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import { InstancesCatalogAuthors } from './authors'
import { InstancesCatalogArts } from './arts'
import styles from './instancesCatalog_catalogizator.jcss'
import {
    CATALOGIZATOR_MODULE_KEY,
    CATALOGIZATOR_TABS,
    CATALOGIZATOR_TITLE_KEY,
    CatalogizatorTab,
} from './InstancesCatalogCatalogizator-types'

const InstancesCatalogCatalogizatorComponent = () => {
    const [activeTab, setActiveTab] = useState<CatalogizatorTab>('authorsList')

    const renderActiveTab = () => {
        switch (activeTab) {
            case 'authorsList':
                return <InstancesCatalogAuthors />
            case 'artsList':
                return <InstancesCatalogArts />
            case 'downloadFromFile':
                return (
                    <div className={cn(grid.w100, grid.flex, grid.center)}>
                        <Uploader uploadMethod={'catalogizatorUploadCsvFile'} isModal={false} />
                    </div>
                )
            default:
                return null
        }
    }

    return (
        <Content title={CATALOGIZATOR_TITLE_KEY}>
            <div className={cn(styles.tabsWrapper, isHorizontalMenu() && styles.tabsWrapper_x)}>
                {CATALOGIZATOR_TABS.map((tab) => (
                    <div
                        key={tab}
                        className={cn(styles.tabBtn, activeTab === tab && styles.tabActive)}
                        onClick={() => setActiveTab(tab)}
                    >
                        {translate(tab)}
                    </div>
                ))}
            </div>
            {renderActiveTab()}
        </Content>
    )
}

export const InstancesCatalogCatalogizator = checkAvailableModule(CATALOGIZATOR_MODULE_KEY)
    ? InstancesCatalogCatalogizatorComponent
    : null
